export const FOOD_TICKET_MANAGER = "talon";
